import React, { Component } from 'react';
import { bool, func, string } from 'prop-types';
import Button from 'ps-components/Button/Button';
import RuleNameDisplay from './RuleNameDisplay/RuleNameDisplay';
import RuleNameEditor from './RuleNameEditor/RuleNameEditor';
import './EditRuleHeader.scss';

class EditRuleHeader extends Component {
  static propTypes = {
    cancelRuleNameEditing: func,
    isDisabled: bool,
    isEditing: bool,
    onEnter: func,
    openJobMatchingSlideout: func,
    ruleName: string,
    saveRuleName: func,
    setRuleName: func,
    startEditingRuleName: func,
    tempName: string
  };

  render() {
    const {
      cancelRuleNameEditing,
      isDisabled,
      isEditing,
      onEnter,
      openJobMatchingSlideout,
      ruleName,
      saveRuleName,
      setRuleName,
      startEditingRuleName,
      tempName
    } = this.props;
    const btnClass = isDisabled ? 'edit__btn edit__btn-disabled' : 'edit__btn';

    return (
      <div className="edit__header-container">
        <div className="edit__header">
          {isEditing ? (
            <RuleNameEditor
              cancelRuleNameEditing={cancelRuleNameEditing}
              onEnter={onEnter}
              ruleName={ruleName}
              saveRuleName={saveRuleName}
              setRuleName={setRuleName}
              tempName={tempName}
            />
          ) : (
            <RuleNameDisplay ruleName={ruleName} startEditingRuleName={startEditingRuleName} />
          )}
        </div>
        <Button className={btnClass} disabled={isDisabled} onClick={openJobMatchingSlideout}>
          Select Jobs
        </Button>
      </div>
    );
  }
}

export default EditRuleHeader;
